export default "__VITE_ASSET__CaQv3gMk__"